import { computed, inject, Signal } from '@angular/core';
import { deepComputed, signalStoreFeature, type, withComputed } from '@ngrx/signals';
import {
  defaultItemPricingModel,
  ItemId,
  ItemPriceUtil,
  ItemPricingEntity,
  ItemPricingModel,
  ItemPricingStore,
  QuantityItemPriceModel,
  stringifyItemId,
} from 'products-data';

// export interface CartItemPricingModel extends ItemPricingModel {
//   itemId: ItemId | null;
//   loading: boolean;
//   error: any;
//   price: QuantityItemPriceModel;
// }

export const withCartItemPricing = () => {
  return signalStoreFeature(
    {
      state: type<{ itemId: ItemId | null }>(),
      props: type<{ cartItemQuantity: Signal<number> }>(),
      // methods: type<MethodsOf<WithCartItemFeature>>(),
    },
    withComputed((store) => {
      const pricingStore = inject(ItemPricingStore);

      const _pricingSig = computed(() => {
        const id = store.itemId();
        if (!id) return null;
        return pricingStore.getItemPricing(id);
      });

      const entity = computed(() => _pricingSig()?.());

      const pricing = computed(() => entity()?.pricing ?? defaultItemPricingModel);

      // const pricing = computed(() => {
      //   console.log('Computing cart item pricing for itemId:', store.itemId(), 'pricing:', entity()?.pricing);
      //   console.log('Converted pricing model:', ItemPriceUtil.convertToPricingModel(entity()?.pricing));
      //   return ItemPriceUtil.convertToPricingModel(entity()?.pricing);
      // });
      const loading = computed(() => _pricingSig()?.loading() ?? true);
      const error = computed(() => _pricingSig()?.error());
      // const price = computed(() => ItemPriceUtil.calculatePrice(store.cartItemQuantity(), pricing()));

      const model = deepComputed((): QuantityItemPriceModel => ItemPriceUtil.calculatePrice(store.cartItemQuantity(), pricing()));

      return {
        cartItemPricing: model,
        cartItemPricingLoading: loading,
        cartItemPricingError: error,
      };
    }),
  );
};
